import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkLineComponent } from '@app/shared/work-line/work-line.component';
import { WorkLinePercentageComponent } from '@app/shared/work-line/work-line-percentage/work-line-percentage.component';
import { WorkLineQuantityComponent } from '@app/shared/work-line/work-line-quantity/work-line-quantity.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EmptyListModule } from '@app/shared/empty-list/empty-list.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportProgressFooterComponent } from '@app/shared/work-line/report-progress-footer/report-progress-footer.component';
import { MatButtonModule } from '@angular/material/button';
import { WorkLineCableComponent } from '@app/shared/work-line/work-line-cable/work-line-cable.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    WorkLineComponent,
    WorkLinePercentageComponent,
    WorkLineQuantityComponent,
    WorkLineCableComponent,
    ReportProgressFooterComponent,
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    EmptyListModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [WorkLineComponent],
})
export class WorkLineModule {}
